/** Display label for company.companyName (repo agency). */
export const BANK_NBFC_NAME_LABEL = "Repo Agency Name";

/** SSDI create repo agency — agency name field label. */
export const AGENCY_NAME_LABEL = "Repo Agency Name";

/** SSDI create page — repo agency wording. */
export const REPOSSESSION_FIRM_AGENCY = "Repo Agency";
export const CREATE_REPOSSESSION_FIRM_AGENCY = "Create Repo Agency";

/** Repo admin — firm & admin settings page. */
export const AGENCY_PROFILE_TITLE = "Profile";
export const AGENCY_PROFILE_MENU_LABEL = "Profile";

/** Repo staff — personal details page. */
export const STAFF_PROFILE_TITLE = "Profile";
export const STAFF_PROFILE_MENU_LABEL = "Profile";
